import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("lk_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("lk_token");
      setUser(false);
    });
  }, []);

  const login = useCallback(async (email, password, portal = "") => {
    const { data } = await api.post("/auth/login", { email, password, portal });
    if (data.twofa_required) return data;
    localStorage.setItem("lk_token", data.token);
    setUser(data);
    return data;
  }, []);

  const finish = useCallback((data) => {
    localStorage.setItem("lk_token", data.token);
    setUser(data);
    return data;
  }, []);
  const verify2fa = useCallback(async (challenge, code) => finish((await api.post("/auth/login/verify", { challenge, code })).data), [finish]);
  const recover = useCallback(async (email, code, new_password) => finish((await api.post("/auth/recover", { email, code, new_password })).data), [finish]);

  const register = useCallback(async (name, email, password, accepted_terms = false) => {
    const { data } = await api.post("/auth/register", { name, email, password, accepted_terms });
    localStorage.setItem("lk_token", data.token);
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("lk_token");
    setUser(false);
  }, []);

  const updateUser = useCallback((patch) => setUser((u) => ({ ...u, ...patch })), []);

  return <AuthCtx.Provider value={{ user, login, register, logout, verify2fa, recover, updateUser }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
